/**
 * IntakeSummary — per-tool detail page shell (Phase X.3.1).
 *
 * Placeholder input + output body. X.3.6 swaps the input placeholder
 * with the structured form + Sonnet 4.7 handler + draft save/load/
 * finalize flow.
 */

import { type ReactNode } from 'react';
import { useTenant } from '@/lib/auth';
import { canUseAiTools } from '@/lib/capabilities';
import { ToolPageShell } from '@/components/aiTools/ToolPageShell';
import { EmptyAiToolsTile } from '@/components/aiTools/EmptyAiToolsTile';
import { AI_TOOLS } from './AiTools';

const TOOL = AI_TOOLS.find((t) => t.slug === 'intake')!;

export function IntakeSummary(): ReactNode {
  const { whoami, tenantSlug } = useTenant();

  if (!canUseAiTools(whoami)) {
    return (
      <main className="max-w-6xl mx-auto px-4 py-6">
        <EmptyAiToolsTile />
      </main>
    );
  }

  return (
    <ToolPageShell
      tool={TOOL}
      tenantSlug={tenantSlug}
      inputPlaceholder={
        <div className="text-center py-8" data-testid="tool-input-placeholder-intake">
          <p className="text-sm font-medium text-ink-soft">Input form lands in X.3.6</p>
          <p className="text-xs text-ink-soft mt-2 max-w-md mx-auto leading-relaxed">
            The Intake Summary Generator form (demographics, referral source, intake-call notes, family context, immediate needs) + Generate path activates with the X.3.6 sub-block.
          </p>
        </div>
      }
    />
  );
}
